import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { RouterProvider } from "./router";
import { SessionProvider } from "./state/session";
import { ToastsProvider } from "./state/toasts";
import "./styles.css";

const container = document.querySelector("#root");
if (!container) throw new Error("Не найден корневой элемент");

createRoot(container).render(
  <StrictMode>
    <RouterProvider>
      <ToastsProvider>
        <SessionProvider>
          <App />
        </SessionProvider>
      </ToastsProvider>
    </RouterProvider>
  </StrictMode>
);
